import React from 'react';

import { useMediaQuery, useTheme } from '@mui/material';

const useWidth = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const isLargeScreen = useMediaQuery(theme.breakpoints?.up('md'));
  const controlSize = isSmallScreen ? 'small' : isLargeScreen ? 'large' : 'medium';

  return controlSize;
};

export default useWidth;
